// src/components/PDFViewer.js
import React, { useEffect, useState } from 'react';
import { CircularProgress, Box, Typography } from '@material-ui/core';
import axios from 'axios';
import { appUrl } from '../../../../../../../../utils/config';

export const PDFViewer = ({ schrockenCustomFileID }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [fileURL, setFileURL] = useState(null);
    const [error, setError] = useState(false)

    useEffect(() => {
        let url = null;
        if (schrockenCustomFileID) {
            const data = {
                schrockenCustomFileID,
            };
            axios
                .post(
                    `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadCustomFile`,
                    data
                )
                .then((res) => {
                    //console.log(res)
                    //console.log(res.data.status)
                    //console.log(res.data.fileData.data)
                    if (res.data.status) {
                        //console.log('inside success')
                        const fileDataArray = res.data.fileData.data;
                        if (!Array.isArray(fileDataArray)) {
                            setError(true)
                        } else {
                            try {
                                const byteArray = new Uint8Array(fileDataArray);
                            const blob = new Blob([byteArray], {
                                type: 'application/pdf',
                            });
                            url = URL.createObjectURL(blob);
                            //console.log(url)
                            setFileURL(url);
                            } catch (err) {
                                setError(true)
                            }
                        }
                        
                    }
                })
                .catch((err) => {
                    console.error('Error loading PDF:', err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }

        return () => {
            if (fileURL) {
                URL.revokeObjectURL(fileURL);
            }
        };
    }, [schrockenCustomFileID]);

    return (
        <Box position="relative" height="800px" border={1} borderColor="grey.300" borderRadius={8} overflow="hidden">
            {isLoading && (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bgcolor="rgba(255, 255, 255, 0.75)"
                >
                    <CircularProgress color="primary" />
                </Box>
            )}
            {error &&
            <Box
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            <Typography>
              Something went wrong. Please try again later.
            </Typography>
                </Box>
            }
            {fileURL && (
                <iframe
                    src={fileURL}
                    style={{ width: '100%', height: '100%' }}
                    title="PDF Viewer"
                    onLoad={() => setIsLoading(false)}
                />
            )}
        </Box>
    );
};
